export const calculatePercentage = (value: number, total: number): number => {
  const percentage = (value / total) * 100;
  return Math.round(percentage * 10) / 10;
};
